// @ts-nocheck
import { useCallback } from 'react';

import useCommon from '../useCommon.js';
import useModelInventory from './useModelInventory';

export default function useSectionPermissions() {
  const { setSectionPermissions, dispatch } = useCommon();
  const { getEntitySectionPermissions } = useModelInventory();

  const handleGetSectionPermission = useCallback(
    (params, loader = true) => {
      getEntitySectionPermissions(params, loader).then((res) => {
        if (res?.data) {
          dispatch(
            setSectionPermissions({
              entity_id: params?.entityId,
              data: res.data,
            })
          );
        }
      });
    },
    [setSectionPermissions, dispatch]
  );

  const handleSetSectionPermission = useCallback(
    (params) => {
      dispatch(
        setSectionPermissions({
          entity_id: params?.entity_id,
          data: params?.data,
        })
      );
    },
    [dispatch]
  );

  return {
    handleGetSectionPermission,
    handleSetSectionPermission,
  };
}
